<template>
  <div class="clearfix">
    <div class="clearfix">
      <Button status="primary" icon="ios-add" @click="createReceiving()"
              v-if="isHavePermission('receiving:createSellerLv2ReceiveGoods:add')">新建结算信息
      </Button>
      <Button status="primary" style="margin-left:10px" @click="importOrder"
              v-if="isHavePermission('receiving:createSellerLv2ReceiveGoods:import')">导入结算信息
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="getRecList" style="margin-left: 20px">刷新</vxe-button>
      <Button icon="md-download" @click="download" style="margin-left: 10px"
              v-if="isHavePermission('receiving:secondSeller:download')"
      >导出
      </Button>

      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form
                :data="searchFormData"
                title-align="left"
            >
              <vxe-form-item title="搜索" field="receiveNum" span="24"
                             :prefix="{icon: 'fa fa-address-card-o'}"></vxe-form-item>
              <vxe-form-item title="结算确认编号" field="receiveNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.receiveNum" placeholder="输入结算确认编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.goodsName" placeholder="输入流程编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起始结算时间" field="addTimeBegin" span="12">
                <template v-slot>
                  <vxe-input type="date" v-model="searchFormData.addTimeBegin" placeholder="选择日期"
                             :transfer="false"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="结束结算时间" field="addTimeEnd" span="12">
                <template v-slot>
                  <vxe-input type="date" v-model="searchFormData.addTimeEnd" placeholder="选择日期"
                             :transfer="false"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="总订单编号" field="chainNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.chainNum" placeholder="输入编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="实际承运人订单编号" field="ordersNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.ordersNum" placeholder="输入编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="实际承运人名称" field="buyerName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSellerName"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'sellerNameOptions','receiving','queryReceiveGoodsKeyword',3)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'sellerNameOptions')"
                      placeholder="输入托运人"
                  >
                    <Option v-for="option in sellerNameOptions" :value="option.text"
                            :key="option.text">{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="所属公司" field="compName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCompName"
                      multiple
                      filterable
                      prefix="ios-arrow-down"
                      :remote-method="(file) => remoteMethod(file,'compNameOptions','receiving','queryReceiveGoodsKeyword',4)"
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'compNameOptions')"
                      placeholder="输入所属公司"
                  >
                    <Option v-for="option in compNameOptions" :value="option.text" :key="option.text">{{ option.text}}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.createUser" placeholder="输入创建人"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="按创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.createTime" :options="timeOptions"
                              placeholder="选择时间"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="附件筛查" field="hasFile" span="12">
                <template v-slot>
                  <vxe-select v-model="searchFormData.hasFile" :options="fileOptions" placeholder="全部"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button status="primary" icon="ios-search" @click="getSearchListKey" style="border-radius: 5px;">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px;border-radius: 5px;">重置</Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal class="timeModal" v-model="open" width="460" height="400" :show-footer="false" :showHeader="false">
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <div class="list-box common-shadow clearfix" style="margin-top: 10px;">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          align="center"
          :show-footer="showFooterFlag"
          max-height="540"
          border="none"
          :loading="loading"
          :data="orderListData"
          :footer-method="footerMethod"
      >
        <vxe-table-column field="id" title="操作" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown trigger="click" style="margin-left: 20px;" transfer
                      v-if="isHavePermission('receiving:updateSellerLv2ReceiveGoods') || isHavePermission('receiving:removeSellerLv2ReceiveGoods')">
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button class="button-gengduo" @click="editReceiving(row)"
                          v-if="isHavePermission('receiving:updateSellerLv2ReceiveGoods')">编辑
                  </Button>
                  <Button
                      class="button-gengduo"
                      style="color: #ed4014;"
                      v-if="isHavePermission('receiving:removeSellerLv2ReceiveGoods')"
                      @click="delReceiving(row)"
                  >删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receiveNum" title="结算确认编号" width="160" show-overflow>
          <template slot-scope="{ row }">
            <span
                @click="openReceivingDeail(row)"
                style="cursor:pointer;color: #2d8cf0;"
            >{{ row.receiveNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addTime" title="结算时间" width="110">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.addTime | timePartRule }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="80" show-overflow></vxe-table-column>
        <vxe-table-column field="goodsRule" title="规格" width="90" show-overflow></vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="55" show-overflow></vxe-table-column>
        <vxe-table-column field="counts" title="实际数量" width="90" show-overflow></vxe-table-column>
        <vxe-table-column field="price" title="单价" width="90" show-overflow></vxe-table-column>
        <vxe-table-column field="receAmount" title="应收总金额" min-width="130" show-overflow></vxe-table-column>
        <vxe-table-column field="note" title="摘要" width="130" show-overflow></vxe-table-column>
        <vxe-table-column field="chainNum" title="主订单编号" width="130">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.chainId, 0)">{{ row.chainNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersSellerNum" title="子订单编号" width="130" show-overflow>
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.ordersSellerLv2Id, 3)"
            >{{ row.ordersSellerLv2Num}}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerLv2Name" title="实际承运人名称" min-width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="compName" title="平台签约企业" width="200" show-overflow></vxe-table-column>
        <vxe-table-column field="createUser" title="客户经理" width="90" show-overflow></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="110" v-if="isHavePermission('global:viewCreateTime')">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timePartRule }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="totalResult"
          @page-change="handleCurrentChange"
      ></vxe-pager>
    </div>
    <vxe-modal
        position="center"
        v-model="createReceivingModal"
        title="新建实际承运人结算信息"
        width="1300"
        top="150"
        height="660"
        resize
        destroy-on-close
        remember
    >
      <create-order-model
          v-bind:showImport="showImport"
          @createCommit="createCommit"
          v-bind:orderType="orderType"
          v-bind:isIncludedTax="isIncludedTax"
      ></create-order-model>
    </vxe-modal>

    <vxe-modal

        v-model="receivingDeailModal"
        width="1300"
        height="700"
        position="center"
        title="实际承运人货物交接结算确认"
        showFooter
    >
      <p slot="title" class="box-tit-211130">
        <span>实际承运人货物交接结算确认</span>
      </p>
      <second-receiving-detail ref="receivingDetail"></second-receiving-detail>
      <div slot="footer">
        <vxe-button
            type="submit"
            status="primary"
            @click="editReceiving(editRows)"
            style="width:140px;border-radius: 0px;"
            v-if="isHavePermission('receiving:updateSellerLv2ReceiveGoods')"
        >编辑
        </vxe-button>
      </div>
    </vxe-modal>
    <vxe-modal
        position="center"
        v-model="logisticDetailVisible"
        title="物流详情"
        width="1300"
        height="600"
        resize
        footer-hide
    >
      <detail-modal ref="modalDetail"></detail-modal>
    </vxe-modal>

    <vxe-modal v-model="logisticsVisible" title="选择物流订单" width="1300" height="600" resize remember position="center">
      <choose-logistics
          ref="chooseLogistics"
          @choose="chooseLogistics"
          @close="closeLogistics"
          v-bind:orderTypeTwo="orderTypeTwo"
          v-bind:orderNum="orderNum"
      ></choose-logistics>
    </vxe-modal>
    <vxe-modal v-model="orderVisible" title="选择订单" width="1450" height="600" resize remember position="center">
      <choose-order-two
          ref="chooseOrderTwo"
          @chooseOrder="chooseOrderTwo"
          v-bind:orderType="orderType"
      ></choose-order-two>
    </vxe-modal>
    <edit-sec-receiving ref="editReceiving" @updateList="updateList"></edit-sec-receiving>
    <vxe-modal
        position="center"
        v-model="templateVisible"
        title="结算信息导入"
        width="1000"
        height="620"
        @close="closeTemplate"
        remember
    >
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <!-- <router-link to="/order/sales/detail/1">承运人订单详情</router-link> -->
  </div>
</template>

<script>
  import CreateOrderModel from "@/views/receiving/CreateReceivingModel"; // 创建新订单
  import $C from "@/consts";
  import XEUtils from "xe-utils/methods/xe-utils";
  import $api from "@/apiProvider";
  import auth from "@/utils/auth";
  import Import from "@/components/common/Import"; // 导入
  import {searchTime, SEARCH_TIME} from "@/filters/time";
  import DetailModal from "@/views/logistics/DetailModal";
  import ChooseLogistics from "@/components/modal/ChooseLogistics";
  import ChooseOrderTwo from "@/components/modal/ChooseOrderTwo";
  import moment from "moment";
  import EditSecReceiving from "@/views/receiving/EditSecReceiving";
  import SecondReceivingDetail from "@/views/receiving/SecondReceivingDetail";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import viewOrderDetail from "@/mixin/viewOrderDetail";
  import {getBlob, hideLoading, isEmpty, saveBlob, showLoading} from "@/utils/util";

  moment.locale("zh-CN");
  export default {
    components: {
      DetailModal,
      CreateOrderModel,
      ChooseLogistics,
      ChooseOrderTwo,
      Import,
      EditSecReceiving,
      SecondReceivingDetail,
    },
    mixins: [getAuthOrization, viewOrderDetail],
    data() {
      return {
        searchLoading: false,
        open: false,
        searchVisible: false,
        searchSellerName: [],
        searchCompName: [],
        sellerNameOptions: [],
        compNameOptions: [],
        fileOptions: $C.HAS_FILE_TYPE.options,
        timeOptions: SEARCH_TIME.options,
        editRows: {},
        showImport: false,
        loading: false,
        orderTypeTwo: 3,
        templateVisible: false,
        orderNum: null,
        deailReceiveNum: null,
        deailCreateUser: null,
        deailCreateTime: null,
        showFooterFlag: false,
        logisticsVisible: false,
        orderVisible: false,
        totalRealCounts: 0,
        trackFlag: false,
        totalReceAmount: 0,
        showPicIndex: 0,
        editUuidList: [],
        logisticDetailVisible: false,
        orderTableData: [],
        receivingTableData: [],
        logisticsTableData: [],
        logisticsShowData: [],
        createReceivingModal: false,
        editReceivingModal: false,
        isShowSearch: false,
        isShowFilter: false,
        orderListData: [],
        formRules: {
          goodsName: [{required: true, message: "请输入货名"}],
          counts: [{required: true, message: "请输入实际数量"}],
          goodsUnit: [{required: true, message: "请输入单位"}],
          addTime: [{required: true, message: "请选择结算时间"}],
          price: [{required: true, message: "请输入单价"}],
          receAmount: [{required: true, message: "请输入总金额"}],
        },
        receivingDeailModal: false,
        currentPage: 1,
        pageSize: 10,
        totalResult: 300,
        currentPage2: 1,
        pageSize2: 5,
        totalResult2: 300,
        currentPage3: 1,
        pageSize3: 5,
        totalResult3: 300,
        orderType: 3,
        isIncludedTax: null,
        searchFormData: {
          addTimeBegin: null,
          addTimeEnd: null,
          chainNum: null,
          compName: null,
          createUser: null,
          goodsName: null,
          createTime: null,
          logisticsNum: null,
          ordersNum: null,
          receiveName: null,
          receiveNum: null,
          receiveType: null,
          updateUser: null,
          sendName: null,
          hasFile: null
        },
        searchFormItems: [
          {
            title: "搜索",
            span: 24,
            titleAlign: "left",
            titleWidth: 200,
            titlePrefix: {icon: "fa fa-address-card-o"},
          },
          {
            field: "receiveNum",
            title: "结算确认编号",
            titleAlign: "left",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入编号"}},
          },
          {
            field: "goodsName",
            titleAlign: "left",
            title: "货名",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入货名"}},
          },
          {
            field: "addTimeBegin",
            titleAlign: "left",
            title: "起始结算时间",
            span: 12,
            itemRender: {
              name: "$input",
              props: {type: "date", placeholder: "请选择日期", transfer: false},
            },
          },
          {
            field: "addTimeEnd",
            titleAlign: "left",
            title: "结束结算时间",
            span: 12,
            itemRender: {
              name: "$input",
              props: {type: "date", placeholder: "请选择日期", transfer: false},
            },
          },
          {
            field: "chainNum",
            titleAlign: "left",
            title: "总订单编号",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入编号"}},
          },
          {
            field: "ordersNum",
            titleAlign: "left",
            title: "实际承运人订单编号",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入编号"}},
          },
          {
            field: "sendName",
            titleAlign: "left",
            title: "实际承运人名称",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入名称"}},
          },
          {
            field: "compName",
            titleAlign: "left",
            title: "所属公司",
            span: 12,
            itemRender: {name: "$input", props: {placeholder: "请输入公司"}},
          },
          {
            field: "createUser",
            titleAlign: "left",
            title: "创建人",
            span: 12,
            itemRender: {
              name: "$input",
              props: {placeholder: "请输入创建人"},
            },
          },
          {
            field: "time",
            title: "按创建时间",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择时间", transfer: false},
              options: SEARCH_TIME.options,
            },
          },
          {
            field: "hasFile",
            title: "附件筛查",
            titleAlign: "left",
            span: 12,
            itemRender: {
              name: "$select",
              props: {placeholder: "请选择是否包含附件", transfer: false},
              options: $C.HAS_FILE_TYPE.options,
            },
          },
          {
            align: "center",
            span: 24,
            titleAlign: "left",
            itemRender: {
              name: "$buttons",
              children: [
                {props: {type: "submit", content: "提交", status: "primary"}},
                {props: {type: "reset", content: "重置"}},
              ],
            },
          },
        ],
        listQuery: {
          page: 1,
          rows: 10,
          orderBy: 2,
          isDesc: 1,
          addTimeBegin: null,
          addTimeEnd: null,
          chainNum: null,
          compName: null,
          createTimeBegin: null,
          createTimeEnd: null,
          createUser: null,
          goodsName: null,
          logisticsNum: null,
          ordersNum: null,
          receiveName: null,
          receiveNum: null,
          receiveType: null,
          updateUser: null,
        },
        receFileList: [],
        uploadData: [
          {
            fileUuidList: [],
          },
        ],
        uploadList: [],
        file: null, // 上传
        actionUrl: "", // 初始化上传地址
        uploadHeaders: {
          Authorization: auth.getAuth().token,
          token: auth.getAuth().token,
        },
      };
    },

    filters: {
      timeRule: function (t) {
        if (t) {
          var timeB = new Date(t);
          var y = 1900 + timeB.getYear();
          var m = "0" + (timeB.getMonth() + 1);
          var d = "0" + timeB.getDate();
          var h = "0" + timeB.getHours();
          var f = "0" + timeB.getMinutes();
          var s = "0" + timeB.getSeconds();

          return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length) +
            " " +
            h.substring(h.length - 2, h.length) +
            ":" +
            f.substring(f.length - 2, f.length) +
            ":" +
            s.substring(s.length - 2, s.length)
          );
        } else {
          return "";
        }
      },
      // 时间显示part（年月日）
      timePartRule: function (t) {
        if (t) {
          var timeB = new Date(t);
          var y = 1900 + timeB.getYear();
          var m = "0" + (timeB.getMonth() + 1);
          var d = "0" + timeB.getDate();

          return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length)
          );
        } else {
          return "";
        }
      },
      // 时间显示part（时分秒）
      timeSfmRule: function (t) {
        if (t) {
          var timeB = new Date(t);
          var h = "0" + timeB.getHours();
          var f = "0" + timeB.getMinutes();
          var s = "0" + timeB.getSeconds();
          return (
            h.substring(h.length - 2, h.length) +
            ":" +
            f.substring(f.length - 2, f.length) +
            ":" +
            s.substring(s.length - 2, s.length)
          );
        } else {
          return "";
        }
      },
    },
    watch: {
      "searchFormData.createTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("createTime");
        },
      },
    },
    mounted() {
      this.$bus.$on("实际承运人结算信息", () => {
        this.reset()
        this.getSearchListKey();
      });
      this.getList('', 'sellerNameOptions', 'receiving', 'queryReceiveGoodsKeyword', 3);
      this.getList('', 'compNameOptions', 'receiving', 'queryReceiveGoodsKeyword', 4);
      this.getRecList();
      this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
    },
    methods: {
      reset() {
        this.searchFormData = {
          addTimeBegin: null,
          addTimeEnd: null,
          sendName: null,
          chainNum: null,
          compName: null,
          createUser: null,
          goodsName: null,
          createTime: null,
          logisticsNum: null,
          ordersNum: null,
          receiveName: null,
          receiveNum: null,
          receiveType: null,
          updateUser: null,
          hasFile: null
        }
        this.searchBuyerName = [];
        this.searchCompName = [];
        this.getList('', 'sellerNameOptions', 'receiving', 'queryReceiveGoodsKeyword', 3);
        this.getList('', 'compNameOptions', 'receiving', 'queryReceiveGoodsKeyword', 4);
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      maxTagPlaceholder(num) {
        return "更多+ " + num;
      },
      remoteMethod(query, options, url, path, columnType) {
        if (query !== "") {
          this.searchLoading = true;
          this.getList(query, options, url, path, columnType);
        } else {
          this[options] = [];
        }
      },
      async getList(query, options, url, path, columnType) {
        let params = {
          columnType: columnType,
        };

        if (!isEmpty(query)) {
          params.keyword = query;
        }
        if (isEmpty(this[options])) {
          this.searchLoading = true;
        }
        let res = await $api[url].post(path, params);
        this.searchLoading = false;
        if (res.status === 1) {
          this[options] = res.data;
        }
      },
      setDefaultOptions(options, option) {
        this[option] = options;
      },
      inputcounts(row) {
        if (row.counts) {
          if (row.price) {
            row.receAmount = Math.round(row.counts * row.price * 100) / 100;
          }
        }
      },
      createReceiving() {
        this.showImport = false;
        this.createReceivingModal = true;
        this.orderType = 3;
        this.isIncludedTax = "实际承运人货物交接确认";
      },
      getSearchListKey() {
        // console.log(obj);
        // this.listQuery = obj;
        // this.listQuery.page = 1;
        // this.listQuery.rows = 10;
        let obj = this.searchFormData;
        let paramsObj = {};
        Object.keys(obj).forEach((key) => {
          if (obj[key] !== null && key !== "time") {
            paramsObj[key] = obj[key];
          }
          if (obj["createTime"] && obj["createTime"].length > 0) {
            paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
            paramsObj.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
          }
        });

        paramsObj.page = 1;
        paramsObj.rows = 10;
        if (this.searchSellerName.length > 0) {
          paramsObj.sendName = this.searchSellerName[0];
        }
        if (this.searchCompName.length > 0) {
          paramsObj.compName = this.searchCompName[0];
        }
        this.listQuery = paramsObj;
        if (obj.addTimeBegin) {
          this.listQuery.addTimeBegin = this.$utils.timestamp(obj.addTimeBegin);
        }
        if (obj.addTimeEnd) {
          this.listQuery.addTimeEnd = this.$utils.timestamp(obj.addTimeEnd);
        }
        this.currentPage = 1;
        this.getRecList();
        this.searchVisible = false;
      },
      async download() {
        if (isEmpty(this.orderListData)) {
          this.$XModal.message("暂无数据")
          return
        }
        let params = this.listQuery
        params.receiveType = 3
        showLoading()
        let res = getBlob("/api/order/receiveGoods/exportReceiveGoodsList", params);
        hideLoading()
        await saveBlob("导出实际承运人结算.xls", res.data)
      },
      chooseLogistics(row) {
        console.log(row);
        var self = this;
        this.logisticsTableData = row;
        this.totalResult2 = this.logisticsTableData.length;
        this.logisticsShowData = this.logisticsTableData.slice(0, 5);
        var logisticsIds = [];
        var addcounts = 0;
        row.forEach(function (item, index) {
          addcounts = addcounts + item.realCount;
        });
        if (addcounts && this.receivingTableData[0].price) {
          this.receivingTableData[0].receAmount =
            Math.round(addcounts * this.receivingTableData[0].price * 100) / 100;
        }
        this.receivingTableData[0].counts = Math.round(addcounts * 100) / 100;
        this.logisticsVisible = false;
      },
      chooseOrderTwo(row) {
        var objOrder = {};
        this.orderTableData = [];
        if (this.orderNum != row.sellerOrdersNum) {
          this.logisticsTableData = [];
          this.logisticsShowData = [];
        }
        this.orderNum = row.sellerOrdersNum;
        this.orderTypeTwo = 3;

        objOrder.ordersBuyerNum = row.buyerOrdersNum;
        objOrder.ordersSellerLv2Num = row.sellerOrdersNum;
        // objOrder.buyerName = row.buyerName;
        objOrder.compName = row.platformCompany;
        objOrder.sellerName = row.parentSellerName;
        objOrder.createUser = row.createUser;
        objOrder.createTime = row.createTime;
        objOrder.chainNum = row.chainNum;
        objOrder.compName = row.platformCompany;
        objOrder.sendName = row.sellerName;

        // objOrder.ordersBuyerId = row.id;
        // objOrder.ordersSellerId = res.id;
        objOrder.ordersSellerLv2Id = row.id;
        this.orderTableData.push(objOrder);

        this.orderVisible = false;
      },
      //获取列表
      async getRecList() {
        this.loading = true;
        // let data = this.listQuery;
        let res = await $api.receiving.request(
          "queryReceiveSellerLv2GoodsList",
          this.listQuery
        );
        if (res.status == 1) {
          this.orderListData = res.data.rows;
          this.totalRealCounts = res.data.countRtnVo.totalRealCounts;
          this.totalReceAmount = res.data.countRtnVo.totalReceAmount;
          this.totalResult = res.data.total;
          if (this.orderListData.length > 0) {
            this.showFooterFlag = true;
          } else {
            this.showFooterFlag = false;
          }

          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
          this.loading = false;
        }
      },
      clearTableV() {
        this.$refs.xTable.clearValidate();
      },
      async validEvent() {
        let errMap = await this.$refs.xTable.validate().catch((errMap) => errMap);
        return errMap ? false : true;
      },
      changeLogistic() {
        if (this.orderTableData[0].ordersSellerLv2Num == null) {
          this.$XModal.alert({
            message: "请先选择订单",
            status: "error",
          });
          return;
        }
        this.logisticsVisible = true;
        this.$refs.chooseLogistics.init();
      },
      closeLogistics() {
        this.logisticsVisible = false;
      },

      changeOrder() {
        this.orderVisible = true;
        this.orderType = 3;
        this.$refs.chooseOrderTwo.init();
      },
      async submitEdit() {
        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return;
        }
        var tempCopy = {
          logisticsIdList: [],
        };
        if (this.receivingTableData[0].addTime) {
          tempCopy.addTime = this.$utils.timestamp(
            this.receivingTableData[0].addTime
          );
        }
        tempCopy.id = this.receivingTableData[0].id;
        tempCopy.receAmount = this.receivingTableData[0].receAmount;
        tempCopy.counts = this.receivingTableData[0].counts;
        tempCopy.price = this.receivingTableData[0].price;
        tempCopy.goodsName = this.receivingTableData[0].goodsName;
        tempCopy.note = this.receivingTableData[0].note;
        tempCopy.goodsRule = this.receivingTableData[0].goodsRule;
        tempCopy.goodsUnit = this.receivingTableData[0].goodsUnit;
        tempCopy.ordersBuyerId = this.orderTableData[0].ordersBuyerId;
        tempCopy.ordersSellerId = this.orderTableData[0].ordersSellerId;
        tempCopy.ordersSellerLv2Id = this.orderTableData[0].ordersSellerLv2Id;
        tempCopy.fileUuidList = this.uploadData[0].fileUuidList;
        this.logisticsTableData.forEach(function (item, index) {
          tempCopy.logisticsIdList.push(item.id);
        });
        console.log(tempCopy);
        let res = await $api.receiving.request(
          "updateSellerLv2ReceiveGoods",
          tempCopy
        );
        if (res.status == 1) {
          this.$Message["success"]({
            background: true,
            content: "更新成功",
          });
          this.editReceivingModal = false;
          this.getRecList();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
          // this.$Message.error(res.message ? res.message : "接口异常");
        }
      },
      cancelSubmit() {
        this.createReceivingModal = false;
        this.editReceivingModal = false;
      },
      resetListQuery() {
        this.listQuery = {
          page: 1,
          rows: 10,
          addTimeBegin: null,
          addTimeEnd: null,
          chainNum: null,
          compName: null,
          createTimeBegin: null,
          createTimeEnd: null,
          createUser: null,
          goodsName: null,
          logisticsNum: null,
          ordersNum: null,
          receiveName: null,
          receiveNum: null,
          receiveType: null,
          updateUser: null,
        };
      },
      handleCurrentChange(val) {
        this.listQuery.page = val.currentPage;
        this.listQuery.rows = val.pageSize;
        this.getRecList();
        console.log(`当前页: ${val}`);
      },
      handleCurrentChange2(val) {
        this.logisticsShowData = this.logisticsTableData.slice(
          (val.currentPage - 1) * val.pageSize,
          val.currentPage * val.pageSize
        );
        console.log(this.logisticsShowData);
      },
      createCommit(val) {
        this.createReceivingModal = val;
        this.getRecList();
      },
      editReceiving(row) {
        this.receivingDeailModal = false;
        this.$refs.editReceiving.editReceiving(row);
      },
      delReceiving(row) {
        this.$XModal.confirm("您确定要删除吗？").then((type) => {
          if (type === "confirm") {
            this.deleteCommit(row);
          }
        });
      },
      async deleteCommit(row) {
        var del = {
          id: row.id,
        };
        let res = await $api.receiving.request(
          "removeSellerLv2ReceiveGoods",
          del
        );
        if (res.status == 1) {
          this.getRecList();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
          // this.$Message.error(res.message ? res.message : "接口异常");
        }
      },
      openReceivingDeail(row) {
        if (!this.isHavePermission('sellerLv2:ReceDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.editRows = row;
        this.receivingDeailModal = true;
        this.$refs.receivingDetail.getReceivingDetail(row);
      },

      async getReceivingDetail(row) {
        var self = this;
        self.currentPage2 = 1;
        self.pageSize2 = 5;
        self.logisticsShowData = [];
        self.receivingTableData = [];
        self.deailReceiveNum = row.receiveNum;
        self.deailCreateUser = row.createUser;
        self.orderTypeTwo = 3;
        self.deailCreateTime = row.createTime;
        self.orderTableData = [];
        self.editUuidList = [];
        self.uploadList = [];
        var objReceive = {};
        var objOrder = {};
        var data = {
          id: row.id,
        };
        let response = await $api.receiving.request(
          "querySellerLv2ReceiveGoodsDetail",
          data
        );
        if (response.status == 1) {
          let res = response.data;
          //结算信息
          // objReceive.addTime = res.addTime;
          objReceive.addTime = this.$utils.toDateString(
            res.addTime,
            "yyyy-MM-dd"
          );
          objReceive.goodsName = res.goodsName;
          objReceive.id = res.id;
          objOrder.chainNum = res.chainNum;
          objOrder.chainId = res.chainId;
          objReceive.goodsRule = res.goodsRule;
          objReceive.goodsUnit = res.goodsUnit;
          objReceive.counts = res.counts;
          objReceive.price = res.price;
          objReceive.receAmount = res.receAmount;
          objReceive.note = res.note;
          self.receivingTableData.push(objReceive);
          console.log(self.receivingTableData);
          //订单信息
          objOrder.ordersBuyerNum = res.ordersBuyerNum;
          objOrder.ordersSellerNum = res.ordersSellerNum;
          objOrder.ordersSellerLv2Num = res.ordersSellerLv2Num;
          self.orderNum = res.ordersSellerLv2Num;
          objOrder.receiveName = res.receiveName;
          objOrder.sendName = res.sendName;
          objOrder.createUser = res.createUser;
          objOrder.createTime = res.createTime;
          objOrder.ordersBuyerId = res.ordersBuyerId;
          objOrder.ordersSellerId = res.ordersSellerId;
          objOrder.ordersSellerLv2Id = res.ordersSellerLv2Id;
          objOrder.compName = res.compName;
          objOrder.buyerName = res.buyerName;
          objOrder.sellerName = res.sellerName;
          self.orderTableData.push(objOrder);
          //物流信息
          self.logisticsTableData = res.logisticsList;
          self.totalResult2 = self.logisticsTableData.length;
          self.logisticsShowData = self.logisticsTableData.slice(0, 5);
          //图片信息
          if (res.fileList != null) {
            res.fileList.map((i) => {
              self.editUuidList.push(i.uuid);
              self.uploadList.push(i);
            });
          }
        }
      },

      footerMethod({columns, data}) {
        const sums1 = [];
        const sums2 = [];
        columns.forEach((column, columnIndex) => {
          if (columnIndex === 0) {
            sums1.push("单页合计");
            sums2.push("全部合计");
          } else {
            let sum1Cell = null;
            let sum2Cell = null;
            switch (column.property) {
              case "counts":
                sum1Cell = XEUtils.sum(data, column.property);
                sum2Cell = this.totalRealCounts;
                break;
              case "receAmount":
                sum1Cell = XEUtils.sum(data, column.property);
                sum2Cell = this.totalReceAmount;
                break;
            }
            sums1.push(sum1Cell);
            sums2.push(sum2Cell);
          }
        });
        // 返回一个二维数组的表尾合计
        return [sums1, sums2];
      },
      showLogisticsDetail(row) {
        if (!this.isHavePermission('logistics:queryLogisticsDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.logisticDetailVisible = true;
        this.$refs.modalDetail.queryLogisticsDetail(row.id);
      },
      clickEvent3(id) {
        this.$refs[id].togglePanel();
      },
      clickFile(url) {
        window.open(url);
      },
      importOrder() {
        this.$refs.modalTemplate.setExport("0609实际供应方货物交接结算确认导入模板.xls");
        this.templateVisible = true;
      },
      goImport() {
        this.templateVisible = false;
        this.createReceiving();
        this.showImport = true;
      },
      closeTemplate() {
        this.templateVisible = false;
      },
      updateList(val) {
        if (val) {
          this.receivingDeailModal = false;
          this.getRecList();
        }
      },
    },
  };
</script>

<style>
  .my-dropdown3 {
    margin-top: 10px;
  }

  .page-con-header {
    margin-bottom: 10px;
    position: relative;
  }

  .fontWeight {
    font-weight: 800;
    line-height: 14px;
    margin-bottom: 10px;
    display: inline-block;
  }

  /* .flexButton {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  } */

  .infoPaddingCss .vxe-input:not(.is--disabled).is--active .vxe-input--inner {
    border: 0px solid #409eff;
  }

  .infoPaddingCss .vxe-input--inner {
    width: 100%;
    height: 100%;
    /* border-radius: 4px; */
    outline: 0;
    padding: 0 0.6em;
    color: #606266;
    border: 0px solid #dcdfe6;
    background-color: #fff;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .button-gengduo {
    border: none;
  }

  .vxe-input--panel.type--date,
  .vxe-input--panel.type--month,
  .vxe-input--panel.type-- week,
  .vxe-input--panel.type--year {
    z-index: 9998 !important;
  }

  .button-gengduo:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
  }

  .trackBox {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 999;
    background: #fff;
  }

  .pdf-box1 {
    display: inline-block;
    position: relative;
    line-height: 60px;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    width: 60px;
    height: 60px;
    overflow: hidden;
  }

  /* .vxe-modal--wrapper{
    top:100px
  } */
  .vxe-modal--wrapper.type--modal .vxe-modal--box {
    top: 5vh;
  }

  .infoPaddingCss .vxe-pager .vxe-pager--sizes {
    width: 7em;
    text-align: center;
    cursor: pointer;
    display: none;
  }
</style>
